import AbstractModal from '../shared/modal';

export default class SavedTireWarrantyDeleteModal extends AbstractModal {

  private readonly deleteButtonSelector: string = '.js-delete';

  constructor(private readonly body: JQuery) {
    super('.js-deleteSavedTireWarrantyModal', '.js-removeSavedTireWarranty', true);
  }

  // eslint-disable-next-line class-methods-use-this
  delete(code: string): JQuery.Promise<any> {
    return $.ajax({
      url: `${code}/delete`,
      method: 'DELETE',
    });
  }

  protected openCallback = (e?: JQuery.ClickEvent): void => {
    if (!e) { return; }
    const warrantyCode = $(e.currentTarget).data('tire-warranty-code') as string;
    $(this.deleteButtonSelector).on('click', (): void => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.delete(warrantyCode)
        .done((): void => {
          window.location.reload();
        })
        .fail((err: { responseJSON: string }): void => {
          window.NotificationHelper.clearNotifications();
          window.NotificationHelper.showError(err.responseJSON);
          this.close();
        });
    });
  };

}
